import { useConfig } from '@/default-config';

export interface KortbetjeningText {
    [k: string]: string;
}

const useText = (): KortbetjeningText => {
    const { text } = useConfig();

    return text;
};

export default useText;
